<template lang="pug">
    .snot22-block(:class="{'snot22-block--re-contact': isReContact, 'snot22-block--addition-only': additionOnly}")
        .snot22-block__row(
            v-for="(item, index) in snot22"
            :key="item.id"
            :class="{old: item.old}"
        )
            .row
                app-datepicker.snot22-block--date(
                    v-model="item.date"
                    label="Дата"
                    :disabled-dates="disabledDates"
                    :error="getFieldError(item, index, 'date')"
                )

                questionnaire-snot22(
                    v-model="item.result"
                    :error="getFieldError(item, index, 'result')"
                    @setProblems="item.problems = $event"
                )

                app-text-field.snot22-block--problems(
                    v-model="item.problems"
                    label="Наиболее выраженные симптомы"
                    :error="getFieldError(item, index, 'problems')"
                )

                app-dropper(
                    :class="{hidden: (isReContact || additionOnly) && item.old}"
                    @click="dropSnot22(index)"
                )
            hr.narrow(v-if="index < snot22.length - 1")
        .br
        app-button(
            plus
            @click="addNewSnot22()"
        ) Добавить
</template>

<script>
import QuestionnaireSnot22 from '@/components/pages/patients/questionnaires/modals/SNOT22';

import { uniqueId } from 'lodash';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';

export default {
    name: 'snot22-block',

    components: {
        QuestionnaireSnot22,
    },

    props: {
        value: {
            type: Array,
            required: true,
        },

        isReContact: {
            type: Boolean,
            required: false,
            default: false,
        },

        additionOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: () => ({
        snot22: [],
    }),

    validations: {
        snot22: {
            $each: {
                date: { required },
                result: { required },
                problems: { required },
            },
        },
    },

    computed: {
        disabledDates() {
            return this.snot22.map(e => e.date);
        },
    },

    watch: {
        snot22(value) {
            this.$emit('input', value);
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.snot22 = this.value;
        });
    },

    methods: {
        addNewSnot22(date = '') {
            this.snot22.push({
                id: uniqueId(),
                date: date,
                result: '',
                problems: '',
            });
            this.$v.$reset();
        },

        dropSnot22(index) {
            this.$confirm({
                message: `Вы действительно хотите удалить блок?`,
                button: {
                    no: 'Нет',
                    yes: 'Да',
                },
                callback: confirm => {
                    if (confirm) {
                        this.snot22 = this.snot22.filter((d, i) => i !== index);
                    }
                },
            });
        },

        getFieldError(item, index, field) {
            if (this.$v.snot22.$each.$iter[index].$dirty && !this.$v.snot22.$each.$iter[index][field].required) {
                return 'Заполните поле';
            } else {
                return null;
            }
        },

        getFieldsForSave() {
            return this.snot22.map(d => {
                return {
                    date_at: moment(d.date).format('YYYY-MM-DD'),
                    result: d.result,
                    problems: d.problems,
                    version: 'SNOT22',
                };
            });
        },

        getFormattedSavedFields(snot22) {
            return snot22.map(d => ({
                id: d.id,
                date: +moment(d.date_at),
                result: d.result,
                problems: d.problems,
                old: true,
            }));
        },
    },
};
</script>

<style lang="scss">
.snot22-block {
    .snot22-block {
        &--date {
            width: rem(168px);
        }

        &--problems {
            width: rem(298px);
        }
    }

    &--re-contact {
        .snot22-block__row.old {
            display: none;
        }
    }

    &--addition-only {
        .snot22-block__row.old {
            .app-datepicker, .app-text-field {
                opacity: 0.5;

                pointer-events: none;
            }
        }
    }

    @include mobile_or_P {
        .snot20-block {
            &--date {
                width: 100%;
            }
        }
    }
}
</style>
